const processContent = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");

    if (src && !src.startsWith("http")) {
      img.setAttribute(
        "src",
        `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
      );
    }
  });

  return doc.body.innerHTML;
};

function Vinculacion({ content }) {
  return (
    <>
      <section className=" bg-slate-50 py-24">
        <div className="w-full max-w-6xl mx-auto   px-6 ">
          <div className="flex justify-center w-full">
            <p className="inline-flex items-center px-4 py-1.5 text-xs font-bold text-slate-700 bg-slate-100 border border-slate-200/80 rounded-full shadow-sm">
              Vinculacion
            </p>
          </div>

          <div
            className="link-with-arrow-1  grid md:grid-cols-2 lg:grid-cols-3 gap-6   "
            dangerouslySetInnerHTML={{
              __html: processContent(content),
            }}
          />
        </div>{" "}
      </section>
    </>
  );
}

export default Vinculacion;
